import React from "react";
import { useNavigate } from "react-router-dom";
import "./index.css";

const cards = [
  {
    title: "India Untamed",
    tag: "South & West India",
    image: "https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxe%2Fgetty-images-2MA8dFvOMec-unsplash.jpg?alt=media&token=ea7b9a48-2811-4706-80a0-3e43662543a7",
    text: "Luxury holiday homes at India's most exotic destinations, offering exclusive stays and experiences for guests and members.",
    link: "/india-untamed",
  },
  {
    title: "Eat · Pray · Love",
    tag: "Global Curations",
    image: "https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxe%2Fgetty-images-jvXdT-TitTs-unsplash.jpg?alt=media&token=3391aeb1-cccd-456e-bb38-046021a86c3f",
    text: "Luxurious homes curated worldwide for unforgettable journeys around gourmet experiences, spirituality, and romance.",
    link: "/eat-pray-love",
  },
  {
    title: "Asia Wanderlust",
    tag: "Bali · Thailand · Vietnam",
    image: "https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxe%2Fgetty-images-053OMOzZAUI-unsplash.jpg?alt=media&token=76216d75-0af4-4463-b559-a4dd96fd96a7",
    text: "Luxury holiday homes at Asia's most stunning destinations, including Bali, Thailand, Vietnam, and India.",
    link: "/asia-wonderlust",
  },
  {
    title: "Ode to the Arts",
    tag: "Architecture & Design",
    image: "https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxe%2Fgetty-images-wnA23EFrwNw-unsplash.jpg?alt=media&token=ffc4bb27-c4bb-4fdb-b20a-47f81ac5874f",
    text: "Exclusive homes for discerning art and architecture aficionados. Immerse yourself in the brilliance of exceptional design.",
    link: "/ode-to-the-arts",
  },
];

const AllPlans = () => {
  const navigate = useNavigate();

  return (
    <section className="ap-section">
      {/* Header */}
      <div className="ap-header">
        <p className="ap-label">Curated Collections</p>
        <h2 className="ap-title">Our Collections</h2>
        <p className="ap-desc">
          A set of 10 luxury holiday homes per segment, specially curated for various categories of members.
          Properties are sold and purchased progressively.
        </p>
        <div className="ap-launch-badge">
          <span className="ap-launch-pre">Our first launch —</span>
          <span className="ap-launch-main">Investment &amp; Memberships Open Now</span>
        </div>
      </div>

      {/* Cards Grid */}
      <div className="ap-grid">
        {cards.map((card, i) => (
          <div key={i} className="ap-card" onClick={() => navigate(card.link)}>
            <div className="ap-card-img-wrap">
              <img src={card.image} alt={card.title} className="ap-card-img" />
              <div className="ap-card-overlay" />
              <div className="ap-card-top">
                <span className="ap-card-tag">{card.tag}</span>
              </div>
              <div className="ap-card-bottom">
                <h3 className="ap-card-title">{card.title}</h3>
              </div>
            </div>
            <div className="ap-card-body">
              <div className="ap-card-accent" />
              <p className="ap-card-text">{card.text}</p>
              <span className="ap-card-cta">Explore →</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AllPlans;
